import { render, staticRenderFns } from "./image.vue?vue&type=template&id=193d8fe9&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"
import style0 from "./image.vue?vue&type=style&index=0&id=193d8fe9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d8fe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193d8fe9')) {
      api.createRecord('193d8fe9', component.options)
    } else {
      api.reload('193d8fe9', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=193d8fe9&scoped=true", function () {
      api.rerender('193d8fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/insights/image.vue"
export default component.exports